exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mgb25[data-v-78b8a8e4] {\n  margin-bottom: 0.130208rem;\n}\n.mgb5[data-v-78b8a8e4] {\n  margin-bottom: 0.026042rem;\n}\n.wl-container[data-v-78b8a8e4] {\n  padding: 0.078125rem;\n  padding-top: 0;\n  color: #444;\n  height: 100%;\n  background: #eff1f5;\n}\n.wl-tab[data-v-78b8a8e4] {\n  background: #ffffff;\n  height: 100%;\n}", ""]);

// exports
